.dividerLabel {
  font-size: 1rem;
  font-weight: 600;
  color: var(--mantine-color-brand-6);
}
